import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  setFieldOutputAccountsType,
  setFieldAccountNumber,
  setFieldBankKey,
  setFieldMemoTag,
  sendForm,
  setFalseFormDisabled,
  initState
} from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/actions';
import { selectHasFormDisabled } from 'mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/selectors';
import {
  hasFieldError,
  selectFirstErrorByFiled,
  clearErrorByField
} from 'mt-react-common/common/reducers/_formErrors/reducer';
import { selectRequestStatusData } from 'mt-react-common/common/reducers/_requestStatus/reducer';
import { sendRequest as sendRequestGetUserOutputAccounts } from 'mt-react-common/common/reducers/_list/reducer';
import { getValueFromRefDataModules } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import DefaultSelect from 'components/Common/Inputs/DefaultSelect';
import { t } from 'utils/translates';

// eslint-disable-next-line react/prefer-stateless-function
class UserOutputCashAccountForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountNumber: this.props.outputAccountsItem.meAccountNumber,
      bankKey: this.props.outputAccountsItem.bankKey,
      memoTag: this.props.outputAccountsItem.memoTag
    };
    this.props.initState();
  }

  componentDidMount() {
    // Если нет номена счета но разблокируем input
    if (!this.state.accountNumber) {
      this.props.setFalseFormDisabled();
    }
    this.props.setFieldAccountNumber(this.state.accountNumber);
    this.props.setFieldBankKey(this.state.bankKey);
    this.props.setFieldMemoTag(this.state.memoTag);
    this.props.setFieldOutputAccountsType(this.props.outputAccountsItem.id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.accountNumber !== this.state.accountNumber) {
      this.props.setFieldAccountNumberOutputCashFrom(this.state.accountNumber);
      this.props.setFieldAccountNumber(this.state.accountNumber);
      if (this.props.hasFieldError('account_number')) {
        this.props.clearErrorByField('account_number');
      }
      if (this.props.hasFieldErrorOutputCashFrom('account_number')) {
        this.props.clearErrorByFieldOutputCashFrom('account_number');
      }
    }
    if (prevState.bankKey !== this.state.bankKey) {
      this.props.setFieldBankKey(this.state.bankKey);
      this.props.setFieldBankKeyOutputCashFrom(this.state.bankKey);
    }
    if (prevState.memoTag !== this.state.memoTag) {
      this.props.setFieldMemoTag(this.state.memoTag);
      this.props.setFieldMemoTagOutputCashFrom(this.state.memoTag);
    }
    if (
      prevProps.requestStatusData.codeResponse !==
        this.props.requestStatusData.codeResponse &&
      this.props.requestStatusData.codeResponse === 200
    ) {
      this.props.sendRequestGetUserOutputAccounts();
    }
  }

  render() {
    const errorDesc = fieldName => {
      if (this.props.hasFieldError(fieldName)) {
        return (
          <React.Fragment>
            <small className="help-block">
              {this.props.selectFirstErrorByFiled(fieldName).message}
            </small>
          </React.Fragment>
        );
      } else if (this.props.hasFieldErrorOutputCashFrom(fieldName)) {
        return (
          <React.Fragment>
            <small className="help-block">
              {
                this.props.selectFirstErrorByFiledOutputCashFrom(fieldName)
                  .message
              }
            </small>
          </React.Fragment>
        );
      }
      return null;
    };

    const getInput = () => {
      if (this.props.outputAccountsItem.slug === 'spb') {
        return (
          <React.Fragment>
            <div style={{ display: 'flex' }}>
              <DefaultSelect
                selectArrItems={this.props.payoutBanks}
                value={this.state.bankKey}
                handleChangeValue={value => {
                  this.setState({
                    bankKey: value
                  });
                }}
                hasDisabled={this.props.hasFormDisabled}
              />
              <input
                style={{ borderLeft: 'none' }}
                onChange={e => {
                  this.setState({
                    accountNumber: e.target.value
                  });
                }}
                value={this.state.accountNumber || ''}
                disabled={this.props.hasFormDisabled}
                type="text"
                className="form-control"
                placeholder={this.props.outputAccountsItem.placeholder}
                id="inputBankCard"
              />
            </div>
          </React.Fragment>
        );
      }
      if (this.props.outputAccountsItem.slug === 'usdt-ton') {
        return (
          <React.Fragment>
            <div style={{ display: 'flex' }}>
              <input
                onChange={e => {
                  this.setState({
                    accountNumber: e.target.value
                  });
                }}
                value={this.state.accountNumber || ''}
                disabled={this.props.hasFormDisabled}
                type="text"
                className="form-control"
                placeholder={this.props.outputAccountsItem.placeholder}
                id="inputBankCard"
              />
              <input
                style={{ borderLeft: 'none' }}
                onChange={e => {
                  this.setState({
                    memoTag: e.target.value
                  });
                }}
                value={this.state.memoTag || ''}
                disabled={this.props.hasFormDisabled}
                type="text"
                className="form-control"
                placeholder={t(
                  'Введите Memo / Tag (доп. идентификатор получателя)'
                )}
                id="inputBankCard"
              />
            </div>
          </React.Fragment>
        );
      }
      return (
        <input
          onChange={e => {
            this.setState({
              accountNumber: e.target.value
            });
          }}
          value={this.state.accountNumber || ''}
          disabled={this.props.hasFormDisabled}
          type="text"
          className="form-control"
          placeholder={this.props.outputAccountsItem.placeholder}
          id="inputBankCard"
        />
      );
    };

    return (
      <React.Fragment>
        <div id="bank-card">
          <div
            className={`form-group p-t-15 p-b-15 m-b-0 ${
              this.props.hasFieldError('bank_key') ||
              this.props.hasFieldError('account_number') ||
              this.props.hasFieldErrorOutputCashFrom('account_number')
                ? 'has-error'
                : ''
            }`}
          >
            <label className="sr-only" htmlFor="inputBankCard">
              {this.props.outputAccountsItem.placeholder}
            </label>
            <div className="input-group">
              {getInput()}
              <span className="input-group-btn">
                {this.props.hasFormDisabled ? (
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={() => this.props.setFalseFormDisabled()}
                  >
                    <i className="fa fa-pencil" /> Изменить
                  </button>
                ) : (
                  <button
                    className="btn btn-default"
                    type="button"
                    onClick={() => {
                      this.props.sendForm();
                    }}
                  >
                    Сохранить
                  </button>
                )}
              </span>
            </div>
            {errorDesc('memo_tag')}
            {errorDesc('bank_key')}
            {errorDesc('account_number')}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

UserOutputCashAccountForm.propTypes = {
  outputAccountsItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string,
    meAccountNumber: PropTypes.string,
    bankKey: PropTypes.string,
    memoTag: PropTypes.string,
    placeholder: PropTypes.string.isRequired
  }).isRequired,

  hasFormDisabled: PropTypes.bool.isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  requestStatusData: PropTypes.shape({
    requestInProcess: PropTypes.bool,
    codeResponse: PropTypes.number
  }).isRequired,

  hasFieldError: PropTypes.func.isRequired,
  selectFirstErrorByFiled: PropTypes.func.isRequired,
  hasFieldErrorOutputCashFrom: PropTypes.func.isRequired,
  selectFirstErrorByFiledOutputCashFrom: PropTypes.func.isRequired,
  clearErrorByField: PropTypes.func.isRequired,
  clearErrorByFieldOutputCashFrom: PropTypes.func.isRequired,
  setFieldAccountNumber: PropTypes.func.isRequired,
  setFieldAccountNumberOutputCashFrom: PropTypes.func.isRequired,
  setFieldBankKey: PropTypes.func.isRequired,
  setFieldBankKeyOutputCashFrom: PropTypes.func.isRequired,
  setFieldOutputAccountsType: PropTypes.func.isRequired,
  setFieldMemoTag: PropTypes.func.isRequired,
  setFieldMemoTagOutputCashFrom: PropTypes.func.isRequired,
  sendForm: PropTypes.func.isRequired,
  setFalseFormDisabled: PropTypes.func.isRequired,
  initState: PropTypes.func.isRequired,

  sendRequestGetUserOutputAccounts: PropTypes.func.isRequired,
  payoutBanks: PropTypes.shape({}).isRequired
};

const mapStateToProps = (state, props) => ({
  hasFormDisabled: selectHasFormDisabled(state, props.reducerName),
  requestStatusData: selectRequestStatusData(props.reducerName, state),
  hasFieldError: fieldName =>
    hasFieldError(state, props.reducerName, fieldName),
  selectFirstErrorByFiled: fieldName =>
    selectFirstErrorByFiled(state, props.reducerName, fieldName),
  hasFieldErrorOutputCashFrom: fieldName =>
    hasFieldError(state, props.reducerNameOutputCashFrom, fieldName),
  selectFirstErrorByFiledOutputCashFrom: fieldName =>
    selectFirstErrorByFiled(state, props.reducerNameOutputCashFrom, fieldName),
  payoutBanks: getValueFromRefDataModules(state, 'payout.payoutBanks')
});

const mapDispatchToProps = (dispatch, props) => ({
  clearErrorByField: value =>
    dispatch(clearErrorByField(props.reducerName, value)),
  clearErrorByFieldOutputCashFrom: value =>
    dispatch(clearErrorByField(props.reducerNameOutputCashFrom, value)),
  setFieldOutputAccountsType: value =>
    dispatch(setFieldOutputAccountsType(props.reducerName, value)),
  setFieldAccountNumber: value =>
    dispatch(setFieldAccountNumber(props.reducerName, value)),
  setFieldAccountNumberOutputCashFrom: value =>
    dispatch(setFieldAccountNumber(props.reducerNameOutputCashFrom, value)),
  setFieldBankKey: value => dispatch(setFieldBankKey(props.reducerName, value)),
  setFieldBankKeyOutputCashFrom: value =>
    dispatch(setFieldBankKey(props.reducerNameOutputCashFrom, value)),
  setFieldMemoTag: value => dispatch(setFieldMemoTag(props.reducerName, value)),
  setFieldMemoTagOutputCashFrom: value =>
    dispatch(setFieldMemoTag(props.reducerNameOutputCashFrom, value)),
  sendForm: () => dispatch(sendForm(props.reducerName)),
  setFalseFormDisabled: () => dispatch(setFalseFormDisabled(props.reducerName)),
  initState: () => dispatch(initState(props.reducerName)),
  sendRequestGetUserOutputAccounts: () =>
    dispatch(
      sendRequestGetUserOutputAccounts(props.reducerNameOutputCashAccounts)
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserOutputCashAccountForm);



// WEBPACK FOOTER //
// ./src/components/UserOutputCash/UserOutputCashForm/UserOutputCashAccountForm/UserOutputCashAccountForm.js